var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "likeList" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "likeListBox" },
      _vm._l(_vm.similarProducts, function(item) {
        return _c(
          "div",
          {
            key: item.productId,
            staticClass: "likeProItem",
            on: {
              click: function($event) {
                return _vm.goToProDetail(item)
              }
            }
          },
          [
            _c("div", { staticClass: "itemImgBox" }, [
              _c("div", { staticClass: "imgBox" }, [
                _c("img", {
                  ref: "getHeight",
                  refInFor: true,
                  attrs: { src: item.image }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("h4", { staticClass: "h4" }, [
                _vm._v(_vm._s(item.productName))
              ])
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "likeProTit" }, [
      _c("div", { staticClass: "likeListTit" }, [
        _c("i"),
        _c("span", [_vm._v("猜您喜欢")]),
        _c("i")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "description" }, [_vm._v("Guess you like it")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0828c8cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0828c8cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/b2c/product/likeList.vue
// module id = null
// module chunks = 